var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExperimentCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20.229111mm",
    height: "19.725927mm",
    viewBox: "0 0 20.229111 19.725927",
    id: "svg1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-267.09022,-205.00572)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2",
    transform: "matrix(1.6975572,0,0,1.6975572,-212.69053,-156.22253)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12",
    transform: "matrix(0.91438163,0,0,0.91438163,24.689719,18.320127)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "UI_Circle_reddish-2",
    d: "m 285.7383,212.68237 -3.51907,3.20666 -0.12654,4.72073 1.77649,3.73863 4.51659,1.04222 4.39411,-1.95646 2.34522,-4.39289 -1.92477,-5.37619 -5.1948,-0.95345 z",
    fill: "#881840",
    style: {
      fill: "#c78b43",
      fillOpacity: 1,
      strokeWidth: 0.20312
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperimentCircle);
export default __webpack_public_path__ + "static/media/ExperimentCircle.a079b8cfcb50ddc644da553ea69dcf70.svg";
export { ForwardRef as ReactComponent };